// NOTE: taken from https://css-tricks.com/snippets/javascript/strip-html-tags-in-javascript/
export function stripTags(str) {
  return str.replace(/(<([^>]+)>)/gi, '');
}

// NOTE: inspired by https://stackoverflow.com/questions/1495822/replacing-nbsp-from-javascript-dom-text-node
export function stripWhitespace(str) {
  return str
    .replace(/\s/g, '')
    .replace(/&nbsp;/g, '')
    .replace(/\u00a0/g, '')
    .replace(/\xA0/g, '');
}
